import Const from "const";

interface SubGroupStruct {
    readonly teamName: string,
    readonly subGroupKey: string,
    readonly subGroupNumber: number,
}

class SubGroup {
    constructor(private readonly data: SubGroupStruct) {
    }
    
    public isPlayerFromSubGroup(player): boolean {
        if (player.isGoalie()) {
            return false;
        }

        if (player.team !== this.data.teamName) {
            return false;
        }

        if (this.data.subGroupKey === 'LG') {
            return Number(player.userLineGroup) === this.data.subGroupNumber;
        } else if (this.data.subGroupKey === 'PL') {
            return Number(player.userPpLine) === this.data.subGroupNumber;
        }

        return false;
    }
}

export class LineupStackExtractor {
    private readonly markedItems: string[] = [];
    private readonly stackedSubGroups: object = {};
    private readonly stackedTeams: object = {};

    constructor(private readonly lineup: string[], private readonly marker) {
        this.markedItems = this.marker.pickMarkedBySuffix(this.lineup);
        this.extractStackedTeams();
        this.extractStackedSubGroups();
    }

    public isPlayerFromFirstStack(player): boolean {
        return this.isPlayerFromStack(player, Const.NHL_LEGACY_TEAM_STACKING_FIRST_STACK);
    }

    public isPlayerFromSecondStack(player): boolean {
        return this.isPlayerFromStack(player, Const.NHL_LEGACY_TEAM_STACKING_SECOND_STACK);
    }

    public isPlayerFromThirdStack(player): boolean {
        return this.isPlayerFromStack(player, Const.NHL_LEGACY_TEAM_STACKING_THIRD_STACK);
    }

    private isPlayerFromStack(player, stackNumber: number): boolean {
        if (!(stackNumber in this.stackedSubGroups)) {
            return false;
        }

        return this.stackedSubGroups[stackNumber].isPlayerFromSubGroup(player);
    }

    private extractStackedTeams(): void {
        this.markedItems.map(markedItem => {
            if (markedItem[0] !== Const.LP_TEAM_GROUP_PREFIX) {
                return;
            }

            const [teamName, stackNumber] = markedItem.replace(Const.LP_TEAM_GROUP_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

            this.stackedTeams[stackNumber] = teamName;
        });
    }

    private extractStackedSubGroups(): void {
        this.markedItems.map(markedItem => {
            if (markedItem[0] !== Const.LP_SUBGROUP_PREFIX) {
                return;
            }

            const [
                teamName,
                stackNumber,
                subGroupKey,
                subGroupNumber,
            ] = markedItem.replace(Const.LP_SUBGROUP_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

            if (this.stackedTeams[stackNumber] === teamName) {
                this.stackedSubGroups[stackNumber] = new SubGroup({
                    teamName,
                    subGroupKey,
                    subGroupNumber: Number(subGroupNumber),
                });
            }
        });
    }
}